import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput, NavParams } from '@ionic/angular';
import { ParkedCartService } from '../../services/parked-cart.service';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-parked-cart-email',
    templateUrl: './parked-cart-email.page.html',
    styleUrls: ['./parked-cart-email.page.scss'],
})

export class ParkedCartEmailPage implements OnInit {

    @ViewChild('email_address_input', { static: false }) email_address_input: IonInput;

    spinner = null;
    parked_cart_id = null;
    cart = null;
    email_address = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private parkedCartService: ParkedCartService,
        public navParams: NavParams,
        private authService: AuthService,
        private apiService: APIService,
        private router: Router,
    ) { }

    ngOnInit() {
        if (this.navParams.get("parked_cart_id")) {
            this.parked_cart_id = this.navParams.get("parked_cart_id");
        }
        this.parkedCartService.getParkedCart(this.parked_cart_id).then((parked_cart) => {
            if (parked_cart) {
                this.cart = parked_cart['cart']
                if (this.cart['person'] && this.cart['person'].email_address) {
                    this.email_address = this.cart['person'].email_address;
                }
            }
        });
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if (this.email_address == null) {
            setTimeout(() => {
                if(this.email_address_input) {
                    this.email_address_input.setFocus();
                }
            }, 200);
        }
    }

    close() {
        this.modalController.dismiss();
    }

    emailParkedCartQuote() {
        if (this.email_address) {

            let validated = true;
            let email_address_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (this.email_address.length && !email_address_regex.test(String(this.email_address).toLowerCase())) {
                this.presentAlert("Problem", "Invalid email address", "");
                validated = false;
            }

            if (validated) {
                this.presentSpinner("Sending email").then(() => {
                    this.authService.isLoggedIn().then(() => {
                        this.apiService.sendParkedCartQuoteEmail(this.cart, this.email_address).then(async () => {
                            await this.spinner.dismiss();
                            await this.modalController.dismiss();
                        })
                        .catch((error) => {
                            if (error) {
                                if(error.status === 400) {
                                    this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to send a quote email.");
                                } 
                                else if(error.status === 403) {
                                    this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to send a quote email.");
                                } 
                                else if(error.status === 404 || error.status === 0) {
                                    this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to send a quote at this time.");
                                }
                            }
                            this.spinner.dismiss();
                        });
                    })
                    .catch(() => {
                        this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                            window.location.reload();
                        });
                    });
                });
            }

        } else {
            this.presentAlert("Problem", "No email address entered", "");
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
